import moment from "moment";

export const formatStartDateIso = (dateVal) => {
  if (!dateVal) return null;
  const str = String(dateVal).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const [y, m, d] = str.split("-").map(Number);
    const localDate = new Date(y, m - 1, d, 0, 0, 0, 0);
    return localDate.toISOString();
  }
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
};

export const formatEndDateIso = (dateVal) => {
  if (!dateVal) return null;
  const str = String(dateVal).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    const [y, m, d] = str.split("-").map(Number);
    const localDate = new Date(y, m - 1, d, 23, 59, 59, 999);
    return localDate.toISOString();
  }
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return null;
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
};

export const formatToLocalDateStr = (dateVal) => {
  if (!dateVal) return "";
  return moment(dateVal).format("YYYY-MM-DD");
};

export const formatToLocalDisplayDate = (dateVal, formatStr = "MMM DD, YYYY") => {
  if (!dateVal) return "";
  return moment(dateVal).format(formatStr);
};
